module.exports = __webpack_public_path__ + "static/media/icon-enable-askIa.825af30a.svg";